import { IEntity } from "../../../../base/types";
import { useFormikContext } from "formik";

export const useFormFieldProps = (name: string) => {
    const { getFieldProps, errors, touched } = useFormikContext<IEntity>() || {}

    let fieldProps = name ? getFieldProps(`['${name}']`) : { value: '' }
    if (fieldProps.value === undefined)
        fieldProps.value = '';

    return { fieldProps, errors, touched }
}
